module.exports = __webpack_public_path__ + "static/media/LogoTappEN.07ffd5ba.svg";